export default "__VITE_ASSET__t$g8HHCI__"